<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Conclusión</v-toolbar-title>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-else>
                        <v-col cols="12" md="7">
                            <div>
                                <span class="type-label-style">Concepto:</span>
                                <multiselect v-model="Conclusiones.Conclusion"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" select-label="Seleccione un documento"
                                    track-by="ceclave" label="ceconcepto" placeholder="Seleccione una opción"
                                    :options="Conclusiones.opcionesConclusiones" :allow-empty="false" :max-height="150">
                                </multiselect>
                                <span v-if="valConclusion" style="color: #FF5C93; font-size: 11px">Campo
                                    requerido</span>
                            </div>
                            <div class="mt-4">
                                <span class="type-label-style">Fecha del movimiento:</span>
                            </div>
                            <v-dialog ref="dialogfh" outlined v-model="modalfh" :return-value.sync="selectedDate"
                                persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="date-align-center">
                                        <v-text-field class="pt-2" v-model="selectedDate" label="" outlined dense
                                            v-bind="attrs" v-on="on" readonly>
                                        </v-text-field>
                                    </div>
                                </template>
                                <v-date-picker v-model="selectedDate" :min="dateComponentConstraints.fechaMinima"
                                    :max="dateComponentConstraints.fechaMaxima" locale="es" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="secondary" @click="modalfh = false">Cancelar</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialogfh.save(selectedDate)">
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-4">
                                <span class="type-label-style">Observaciones:</span>
                                <v-textarea style="padding-left: 0px !important;" v-on:blur=" observaciones != null ? observaciones != '' ? observaciones = observaciones.trim() : null : null
                " v-model="observaciones" id="textareaobs" :rules="rulestextarea" outlined
                                    :maxlength="$store.state.maxLengthComentarios"
                                    :counter="$store.state.maxLengthComentarios"></v-textarea>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>

            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" @click="saveConclusion()"
                        :disabled="disBtn">Guardar</v-btn>
                    <v-btn class="ma-2" color="default" :disabled="disBtn" @click="limpiar()">Limpiar</v-btn>
                    <v-btn class="ma-2" color="error" @click="cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import ConclusionServ from '@/services/Conclusion/Conclusion.service.js';
import reporteGeneral from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            loaded: false,
            modalfh: false,
            selectedDate: "",
            dateComponentConstraints: {},
            disBtn: true,
            observaciones: "",
            rulestextarea: [
                (v) => !!v || "Campo requerido",
                (v) => {
                    if (v == null) {
                        return true;
                    } else {
                        if (v.trim().length < 16) {
                            return "Mínimo 16 Carácteres";
                        } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                        } else return true;
                    }
                },
            ],
            Conclusiones: {
                opcionesConclusiones: [],
                ceclave: 0,
                ceconcepto: null,
                Conclusion: null
            },
            valConclusion: false,
            svfhreporte: null,
            validForm: true,
            reporte: {},
            permisoRLV: false,
            permisoAJ: false,
            permisoRobo: false,
            permisoRCM: false,
            permisoCivil: false,
        };
    },
    watch: {
        'Conclusiones.Conclusion'(val) {
            if (val != null) {
                this.valConclusion = false;
            }
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    async beforeMount() {
        this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '134,135,156,158,370').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 134)//Permiso para concluir reporte RLV
                        this.permisoRLV = true;
                    if (permiso.peclave == 135)//Permiso para concluir reporte AJ
                        this.permisoAJ = true;
                    if (permiso.peclave == 156)//Permiso para concluir reporte Robo
                        this.permisoRobo = true;
                    if (permiso.peclave == 158)//Permiso para concluir reporte RCM
                        this.permisoRCM = true;
                    if (permiso.peclave == 370)//Permiso para concluir reporte Civil
                        this.permisoCivil = true;
                });
                if (this.reporte.aiclave == 1 && this.permisoAJ == false) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                } else if (this.reporte.aiclave == 5 && this.permisoRCM == false) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                } else if (this.reporte.aiclave == 23 && this.permisoRLV == false) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                } else if (this.reporte.aiclave == 24 && this.permisoRobo == false) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                } else if (this.reporte.aiclave == 27 && this.permisoCivil == false) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
        let valestatus = await MetodosGenerales.getReporteEstatus(this);
        if (valestatus == 2) {
            this.$router.go(-1);
        }
    },
    async mounted() {
        this.changeReporteMenuOption('NoView');
        this.$store.state.reporteMenuOption = 'NoView';

        this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
        let val = await ConclusionServ.ValidarConclusion(this.reporte);
        if (typeof this.$route.params.auxtipo == 'undefined') {
            if (val.mensaje != "") {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Información",
                    html: `${val.mensaje}`,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: '#536DFE',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,
                }).then(async () => {
                    if (val.tipo == 1) {
                        await this.getDatosGenerales(1);
                    }
                });
            } else {
                await this.getDatosGenerales(0);
            }
        } else {
            await this.getDatosGenerales(this.$route.params.auxtipo);
        }
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        handleCopy(event) {
            event.preventDefault();
        },
        async getDatosGenerales(tipo) {
            let today = new Date().toJSON().slice(0, 10);
            this.selectedDate = today;
            this.dateComponentConstraints.fechaMaxima = today;
            let response = await reporteGeneral.fechaSvreporte(this, this.reporte);
            this.svfhreporte = response[0]["svfhreporte"];
            this.dateComponentConstraints.fechaMinima = this.svfhreporte
            this.loaded = true;
            await ConclusionServ.CeclavesConclusion(this, tipo);
            this.disBtn = false;
        },
        cancelar() {
            this.$router.go(-1);
        },
        async limpiar() {
            await this.$refs.form.reset();
            let today = new Date().toJSON().slice(0, 10);
            this.dateComponentConstraints.fechaMaxima = today;
            this.selectedDate = today;
            this.dateComponentConstraints.fechaMinima = this.svfhreporte
            this.Conclusiones.Conclusion = null;

        },
        async saveConclusion() {
            this.disBtn = true;
            let val = await this.validarForm();
            if (val) {
                this.$swal({
                    position: "center",
                    title: "Cargando...",
                    html: "Espere un momento por favor",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                });
                this.$swal.showLoading();
                let response = await ConclusionServ.GuardarConclusion(this.reporte, this.Conclusiones.Conclusion.ceclave, this.selectedDate, this.observaciones);
                if (response.success == true) {
                    let mensaje = '';
                    if (response.result.length == 0) {
                    }
                    else {
                        mensaje = "No se envió el comentario de conclusión, tiene que enviarlo de manera manual";
                    }

                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Éxito!",
                        html: "Se realizó de manera exitosa la conclusión del reporte.<br/>" + mensaje,
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: '#536DFE',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then(() => {
                        this.$emit('ReloadEncabezado');
                        this.$router.go(-1);
                    });
                } else {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Ocurrió un error al intentar concluir el reporte, inténtelo más tarde.",
                        html: "Hubo un error inténtelo de nuevo.",
                        showConfirmButton: false,
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: '#536DFE',
                        showConfirmButton: true,

                    });
                    this.disBtn = false;
                }
            } else {
                this.disBtn = false;
            }
        },
        async validarForm() {
            this.valConclusion = this.Conclusiones.Conclusion == null ? true : false;
            if (this.$refs.form.validate() && this.valConclusion == false) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>